import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../redux/store/store';
import AuthScreens from './auth-screens';
import { PublicScreens, publicScreenRoute } from './public-screens';
import '../styles/style.css';

// Strip a trailing slash so "/privacy-policy" and "/privacy-policy/" match
// the same route.
const path = window.location.pathname.replace(/\/+$/, '') || '/';

export const App: React.FC = () => {
  const isAuthenticated = useSelector((s: RootState) => s.layout.isAuthenticated);

  // Public marketing/legal pages (see publicScreenRoute in public-screens.tsx)
  // must render on a fresh, unauthenticated direct URL load (no clicking
  // through the app first) — e.g. the Play Store's automated privacy-policy
  // URL checker. Checked before the auth branch below so it works regardless
  // of session state.
  const directRoute = publicScreenRoute.find((r) => r.route === path);
  if (directRoute) {
    const Screen = directRoute.screen;
    return <Screen onBack={() => { window.location.href = '/'; }} />;
  }

  return isAuthenticated ? <AuthScreens /> : <PublicScreens />;
};
